import React, { useState } from 'react';
import './SubmitButton.css';

const PredictionSubmitButton = (props) => {
  // Demo state - you'll integrate this with your actual form state
  
  const progress = (props.answeredQuestions / props.totalQuestions) * 100;
  const isComplete = props.answeredQuestions === props.totalQuestions;
  
  const handleSubmit = () => {

    console.log("Submit button clicked");
      props.onSubmit(); // Call the passed in submit function
      // Your submit logic here
  };

  return (
    <div className="submit-container">
    <div className="button-wrapper">
      <button
        onClick={handleSubmit}
        disabled={props.isLoading}
        className={`submit-button ${
          props.isLoading ? 'submit-button-loading' : 'submit-button-active'
        }`}
      >
        {props.isLoading ? (
          <span className="button-content">
            <span className="spinner"></span>
            <span className="button-text">Submitting...</span>
          </span>
        ) : (
          <span className="button-text">
            {!props.hasUpdates ? (
              isComplete ? 'Submit Predictions' : `Answer All Questions (${props.answeredQuestions}/${props.totalQuestions})`
            ) : (
              'Update'
            )}
          </span>
        )}
      </button>
      
      <div className="progress-bar-container">
        <div 
          className="progress-bar-fill"
          style={{ width: `${!props.hasUpdates ?100:progress}%` }}
        />
      </div>
    </div>
  </div>
  );
};

export default PredictionSubmitButton;